import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { useTableInterview } from '../../../context/table-interview-context';

const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKey = '@empretec:cpfSearched';

export function useGeneralSearch() {
  const [cpfSearched, setCpfSearched] = React.useState('');
  const { fetchData } = useTableInterview();

  const handleCpfSearched = React.useCallback((value) => {
    setCpfSearched(value);
    cache.setItem(cacheKey, value);
  }, []);

  const fetchDataInterview = React.useCallback(() => {
    fetchData({ sort: { type: 'DESC' } });
  }, [fetchData]);

  const clear = React.useCallback(() => {
    setCpfSearched('');
    cache.removeItem(cacheKey);
  }, []);

  React.useEffect(() => {
    if (cache.hasItem(cacheKey)) {
      setCpfSearched(cache.getItem(cacheKey));
    }
  }, []);

  return {
    handleCpfSearched,
    clear,
    cpfSearched,
    setCpfSearched,
    fetchDataInterview,
  };
}
